// extracted by mini-css-extract-plugin
export default {"layoutwrapper":"LayoutWrapper_layoutwrapper__RN2dp"};